﻿/**
 * Returns the complement of a value relative to a total (default 100).
 * Example: complementOf(40) === 60
 *
 * @param {number|string} value - The value to subtract from total. Non-numeric values become 0.
 * @param {number} [total=100] - The whole that value should sum up to.
 * @returns {number} total - value
 */
export const complementOf = (value, total = 100) => total - Number(value || 0);

